import axios from 'axios'
import router from '@/router/index.js'
import ElementUI from 'element-ui'
import Vue from 'vue'
import tools from '@/util/tools'
import store from '@/store'
import global from '@/config/global_config'

var httpClient = axios.create({
	baseURL:global.apiBaseURL,
	timeout: 10000,
	withCredentials: true
});

httpClient.interceptors.request.use(
    config => {
		var user = sessionStorage.getItem('user');
		if(user){
			user = JSON.parse(user);
			if (user.accessToken) {
				config.headers.access_token = user.accessToken;
			}
		}
		return config
    },
    err => {
        return Promise.reject(err);
	}
);

httpClient.interceptors.response.use(
    response => {
		if (response.data.code != 200) {
			let message = '';
			switch (response.data.code) {
				case 402:
					sessionStorage.removeItem('user');
					sessionStorage.removeItem('localRoutes');
					message = response.data.msg;
					setTimeout(function(){router.push('/login');location.reload();}, 2000);
					break;
				case 500:
					message = '服务内部错误，请稍后重试';
					break;
				default:
				    if(response.data.errorMap){
						let errorMapTemp = '';
						Object.keys(response.data.errorMap).forEach(key => {
							errorMapTemp +=  key+"字段:"+response.data.errorMap[key]+','
						});
						message = response.data.msg + '(详细原因：'+ errorMapTemp +')';
					}
					else
				    message = response.data.msg;
			}
			if(message) throw new Error(message);
			else return response;
		}
		else 
			return response;
    },
    error => {
		console.log(error);
		if (error.message.indexOf('401') != -1) {
			sessionStorage.removeItem('user');
			tools.error(new Vue(),'会话已过期,请重新登录');
			router.push('/login');
		} else {
			error.message = '服务暂时不可用，请稍候重试!';
			return Promise.reject(error);
		}
	}
);

export default httpClient;


// WEBPACK FOOTER //
// ./src/util/http.js